import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ConvertToString from "../../../../../../components/Converter";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../../../components/styledComponents/Result";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";
import { berechneQuerschnittsnachweis } from "../../../../../../services/knickenBerechnungen.service";
import { selectBemessungslast } from "../../../../../../store/slices/bemessungslastSlice";
import {
  selectQuerschnittsnachweis,
  setQuerschnittsnachweis,
} from "../../../../../../store/slices/innereSlice";

function Querschnittsnachweis({
  knicklastDesGebettetenPfahls,
  normalkrafttragfaehigkeit,
  biegemomentdesPfahls,
  elastischeMomententragfaehigkeit,
}) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const eta_0_Formula = `\\displaystyle \\eta = \\frac {N_{\\small {Fd}}} {N_{\\small{Rd}}} + \\frac{M_{\\small{Fd}}}{M_{\\small{Rd}}} \\le 1,0`;

  const bemessungswertDruckkraft = Number(useSelector(selectBemessungslast));
  const querschnittsnachweis = useSelector(selectQuerschnittsnachweis);

  function isValid() {
    if (querschnittsnachweis === "") return false;

    return querschnittsnachweis <= 1 && bemessungswertDruckkraft <= knicklastDesGebettetenPfahls
      ? true
      : false;
  }

  useEffect(() => {
    dispatch(
      setQuerschnittsnachweis(
        berechneQuerschnittsnachweis(
          Number(bemessungswertDruckkraft),
          Number(normalkrafttragfaehigkeit),
          Number(biegemomentdesPfahls),
          Number(elastischeMomententragfaehigkeit)
        )
      )
    );
  }, [
    bemessungswertDruckkraft,
    normalkrafttragfaehigkeit,
    biegemomentdesPfahls,
    elastischeMomententragfaehigkeit,
  ]);

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.crossSectionVerification")}</p>}
      indicesValue={<span>&eta;</span>}
      formulaValue={
        <ToolTip id={"eta_0_Formula"} type={IconType.FORMULA} formula={eta_0_Formula} />
      }
      inputValue={
        <ResultSpan valid={isValid()}>
          {bemessungswertDruckkraft > knicklastDesGebettetenPfahls
            ? "XXX"
            : ConvertToString(querschnittsnachweis, 2, "XXX")}
        </ResultSpan>
      }
    />
  );
}

export default Querschnittsnachweis;
